import React from 'react';

import BaseComponent from '../../../baseClasses/BaseComponent';
import downloadIcon from '../../../assets/images/por-export-icon.svg';
import downloadActiveIcon from '../../../assets/images/por-export-active-icon.svg';

import './ZipExportButton.scss';
import { FileNamePopUp } from '../../../components/FileNamePopup';

class ZipExportButton extends BaseComponent {

  constructor(props) {
    super(props);
    
    this.state= { 
      initializeMe: null,
      displayPopUp: null,
      fileName: this.props.filename,
      change: false,
      tab: null,
      newTab: null,
    };
  
    this.changeFileName = this.changeFileName.bind(this);
    this.handleResetFileName = this.handleResetFileName.bind(this);
  }

  changeFileName(value) {
    this.setState({ fileName: value });
  }

  handleResetFileName(state) {
    this.setState({  change: state });
  }

  handleDownloadLocation() {
    this.setState({ displayPopUp: true });
    const emailButtonContainer = document.querySelector('.email-button-container');
    if (emailButtonContainer) {
      emailButtonContainer.style.zIndex = 0;
    }
    return; 
  }

  handleClosePopup() {
    this.setState({ displayPopUp: false });
    const emailButtonContainer = document.querySelector('.email-button-container');
    if (emailButtonContainer) {
      emailButtonContainer.style.zIndex = 1;
    }
  }

  render() {
    const { attachments, which, filename, enabled, popupUbication, queryParamName } = this.props;
    // When provided (e.g. 'progressReportId'), use as query param name instead of which, so backend can distinguish progress reports from closeouts
    const paramName = (queryParamName != null && queryParamName !== '') ? queryParamName : which;

    let initialName = null;
    let tabChange = null;
    if (!this.state.change && this.props.filename) {
      initialName = this.props.filename.split(/\.(?=[\w])/);
      this.state.fileName = initialName[0];
    }
    if (this.props.tab && popupUbication === 'POR') {
      this.state.tab = this.props.tab;
      tabChange = this.props.tab;
    } else {
      tabChange = 'change';
    }

    if (tabChange === 'change') {
      this.state.displayPopUp = null;
    }
    let attachmentIds = '';
    if (attachments && attachments.length > 0) {
      for (let i = 0; i < attachments.length; i++) {
        attachmentIds += (i > 0 ? ',' : '') + attachments[i];
      }
    }
    const safeFilename = filename ? encodeURIComponent(filename) : null;
    const hasValidIds = attachmentIds.length > 0;

    let path = null;
    if (enabled && safeFilename && hasValidIds && process.env.REACT_APP_API) {
      path =
        `${process.env.REACT_APP_API}/zip-${which}?${paramName}=${attachmentIds}&filename=${encodeURIComponent(this.state.fileName)}&current_company=${localStorage.current_company_id}&token=${localStorage.token}`;
    }

    let popUp = this.state.displayPopUp && <FileNamePopUp handleClosePopup={this.handleClosePopup} which={this.props.which} handleResetFileName={this.handleResetFileName}
     fileUrl={path} onChange={this.changeFileName} popupUbication={''} initialName={this.state.fileName} staticName={this.props.filename} 
     handleDownload={this.props.handleDownload} tab={this.state.tab} actualTab={this.props.tab} attachmentIds={attachments}/>;
    
    return (

      <div className={'zip-export-button' + (enabled ? ' enabled': '')}>
        {popUp}
        <a className="zip-export-button--download" onClick={enabled ? ()=> this.handleDownloadLocation() : null}>
          <img className='zip-export-button--icon' src={enabled ? downloadActiveIcon : downloadIcon} alt="download"/>
        </a>
      </div>
    );
  }
}

export default (ZipExportButton);



// WEBPACK FOOTER //
// ./src/containers/PORContainer/ZipExportButton/index.js